import { render } from "./TheFooter.vue?vue&type=template&id=17c49cbb&scoped=true&bindings={}"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-17c49cbb"

export default script